<div class="card card-custom gutter-b example example-compact top-align">
  <div class="card-header">
      <h3 class="card-title">Training Partner Feedback Form</h3>
      <div class="card-toolbar">
          <div class="example-tools justify-content-center">
              <span class="example-toggle" data-toggle="tooltip" title="" data-original-title="View code"></span>
              <span class="example-copy" data-toggle="tooltip" title="" data-original-title="Copy code"></span>
          </div>
      </div>
  </div>
  <div class="card-body" *ngIf="showLabel">
    <h2 >No Feedback Available</h2>
  </div>
  <div class="card-body" >
      <form class="form" [formGroup]="tpFeedbackForm">
        <ng-container *ngIf="!hideForm">
          <div   formArrayName="feedbacks"
          *ngFor="let question of tpFeedbackForm.get('feedbacks')['controls']; let i = index" class="form-group">
          <ng-container [formGroupName]="i">

            <div  formGroupName="feedback">
                <label class="label-text" >{{questions[i].id}}) {{questions[i].questionString}}</label>
                <ng-container *ngIf="questions[i].id !== 'Q2'">
                  <ng-container *ngIf="questions[i].id !== 'Q4'">
                    <div class="radio-list">
                      <label style="margin-left: 20px;" class="radio">
                          <input type="radio" (change)="validate(i)" formControlName="choice"  [value]="true" >
                          <span></span>
                          Yes
                      </label>
                      <label style="margin-left: 20px;"  class="radio">
                        <input type="radio" (change)="validate(i)"  formControlName="choice"  [value]="false" >
                        <span></span>
                        No
                    </label>
                  </div>
                  </ng-container>
                
                </ng-container>
                <ng-container *ngIf="questions[i].id === 'Q2'"> 
                  <div class="radio-list">
                    <label style="margin-left: 20px;" class="radio">
                        <input type="radio"  (change)="showInputs(i)"  formControlName="choice"  value="Portal is slow" >
                        <span></span>
                        Portal is slow
                    </label>
                    <label style="margin-left: 20px;"  class="radio">
                      <input type="radio" (change)="showInputs(i)"   formControlName="choice"  value="Process is complicated" >
                      <span></span>
                      Process is complicated
                  </label>
                  <label style="margin-left: 20px;"  class="radio">
                    <input type="radio" (change)="showInputs(i)"   formControlName="choice"  value="Too many errors" >
                    <span></span>
                    Too many errors
                </label>
                <label style="margin-left: 20px;"  class="radio">
                  <input (change)="showInputs(i)" type="radio"  formControlName="choice"  value="Others" >
                  <span></span>
                  Others
              </label>
              <div *ngIf="othersInput" class="form-group">
                <input style="width: 32%;" formControlName="others"  type="text" maxlength="50"  class="form-control" placeholder="Write your asnwer ( max character: 50 )">
              </div>
                </div>
                </ng-container>

                <ng-container *ngIf="questions[i].id === 'Q4'"> 
                  <div class="radio-list">
                    <label style="margin-left: 20px;" class="radio">
                        <input type="radio" (change)="otherInputQFour(i)"  formControlName="choice"  value="– Webinar or walk through of Skill India Digital" >
                        <span></span>
                      Webinar or walk through of Skill India Digital Hub
                    </label>
                    <label style="margin-left: 20px;"  class="radio">
                      <input type="radio" (change)="otherInputQFour(i)"  formControlName="choice"  value="Portal, Regular interaction with SPOC" >
                      <span></span>
                      Portal, Regular interaction with SPOC
                  </label>
                  <label style="margin-left: 20px;"  class="radio">
                    <input type="radio" (change)="otherInputQFour(i)"  formControlName="choice"  value="Timely
                    resolution of queries" >
                    <span></span>
                    Timely
                    resolution of queries,
                </label>
                <label style="margin-left: 20px;"  class="radio">
                  <input type="radio" (change)="otherInputQFour(i)" formControlName="choice"  value="Others" >
                  <span></span>
                  Others
              </label>
              <div *ngIf="QFourInput" class="form-group">
                <input style="width: 32%;" formControlName="others"  type="text" maxlength="50"  class="form-control" placeholder="Write your asnwer ( max character: 50 )">
              </div>
                </div>
                </ng-container>
               
              </div>
          </ng-container>
          </div>
        </ng-container>
       
          <div class="card-footer">
            <ng-container *ngIf="!isUpdate">
              <button *ngIf="role !== 'Continuous Monitoring'" [disabled]="tpFeedbackForm.status === 'INVALID'" class="btn btn-primary mr-2"  (click)="sumitFeedback()">Submit</button>
              <!-- <button *ngIf="role !== 'Continuous Monitoring'"  class="btn btn-primary mr-2"  (click)="reset()">Reset</button> -->

            </ng-container>
            <button class="btn btn-secondary" (click)="goBack()">Back</button>
          </div>
      </form>
</div>
</div>

   